import { render, staticRenderFns } from "./CategoriesSlider.vue?vue&type=template&id=9602bc4a&"
import script from "./CategoriesSlider.vue?vue&type=script&lang=js&"
export * from "./CategoriesSlider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports